import { MOTIF_PATHS, posterFor, titleLines, type PosterItem, type PosterSpec } from './poster-art';

export { titleLines };

/**
 * 16:9 poster: the programme's own poster frame when it has one, else generated art (see
 * poster-art.ts). Decorative for assistive technology: the programme
 * title is always also present as real text next to the poster.
 */
export function PosterArt({
  item,
  sampleLabel,
  showTitle = true,
  mark = true,
}: {
  item: PosterItem;
  sampleLabel: string;
  showTitle?: boolean;
  /** Draw the "Fictional sample" mark inside the art (cards draw their own label instead). */
  mark?: boolean;
}) {
  const spec = posterFor(item);
  return (
    <svg
      className="poster-art"
      viewBox="0 0 320 180"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      focusable="false"
    >
      {spec.image ? (
        <>
          <image href={spec.image} width="320" height="180" preserveAspectRatio="xMidYMid slice" />
          {showTitle && (
            <rect
              width="320"
              height={22 + titleLines(spec.title).length * 30}
              fill="#1d3036"
              opacity="0.82"
            />
          )}
        </>
      ) : (
        <>
          <rect width="320" height="180" fill={spec.background} />
          {MOTIF_PATHS[spec.motif].map((d) => (
            <path
              key={d}
              d={d}
              fill={spec.shape}
              stroke={spec.shape}
              strokeWidth={6}
              strokeLinejoin="round"
            />
          ))}
        </>
      )}
      {showTitle && (
        <text
          x="20"
          y="42"
          fill={spec.image ? '#ffffff' : spec.ink}
          className="poster-art__title"
          lang={spec.lang}
        >
          {wrapTitle(spec)}
        </text>
      )}
      {mark && (
        <g className="poster-art__mark">
          <rect
            x="12"
            y="150"
            width={sampleLabel.length * 7 + 16}
            height="20"
            rx="4"
            fill="#1d3036"
          />
          <text x="20" y="164" fill="#ffffff">
            {sampleLabel}
          </text>
        </g>
      )}
    </svg>
  );
}

function wrapTitle(spec: PosterSpec) {
  return titleLines(spec.title).map((line, i) => (
    <tspan key={i} x="20" dy={i === 0 ? 0 : 30}>
      {line}
    </tspan>
  ));
}
